import React from 'react';
import { Link } from 'react-router-dom';

const NotFound = () => {
  return (
    <div className="container mx-auto px-4 py-32 text-center flex-grow flex flex-col items-center justify-center">
      <h1 className="text-5xl font-bold mb-4 text-gray-900">404</h1>
      <p className="text-xl text-gray-600 mb-8">Page not found</p>
      <Link 
        to="/" 
        className="px-6 py-2 bg-gray-900 text-white rounded-md hover:bg-gray-800 transition-colors"
      >
        Return to Home
      </Link>
    </div>
  );
};

export default NotFound;